import angular from 'angular';
import moment from "angular-moment";
import SaConfigService from '../../components/api/sa_config/sa_config.service';

import './compare-modal.css';

export class CompareModalController {
  /*@ngInject*/
  constructor($cookies, $mdDialog, $stateParams, SaConfigService) {
    this.SaConfigService = SaConfigService;
    this.$cookies = $cookies;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;

    this.sa_configs = [];
    this.type = this.$cookies.get('report_type') || 'demand';
    this.term = this.$cookies.get('report_term') || 'daily';
    this.graphType = 'bar';

    /*@ngInject*/
    this.CompareDialogController = ($scope, $mdDialog, $state, sa_configs, type, term, graphType) => {
      $scope.sa_configs = sa_configs;
      $scope.type = type;
      $scope.term = term;
      $scope.graphType = graphType;

      const currentConfig = $scope.sa_configs.find(e => e.id == this.$stateParams.id);
      if (currentConfig) {
        currentConfig.checked = true;
      }

      $scope.closeDialog = function() {
        $mdDialog.hide();
      };

      $scope.submit = function() {
        $mdDialog.hide();
        const checkedList = $scope.sa_configs.filter(e => e.checked);
        $state.go('main.compare_graph_show', {
          ids: checkedList.map(e => e.id),
          type: $scope.type,
          term: $scope.term,
          graphType: $scope.graphType
        });
      }
    }
  }

  $onInit() {
    this.text = this.value || '他の拠点と比較';
    this.SaConfigService.api.index(res => {
      this.sa_configs = res;
    });
  }

  showDialog($event) {
    const parent = angular.element(document.body);
    this.$mdDialog.show({
      parent: parent,
      targetEvent: $event,
      template: require('./compare-modal.tmpl.html'),
      locals: {
        sa_configs: this.sa_configs,
        type: this.type,
        term: this.term,
        graphType: this.graphType
      },
      controller: this.CompareDialogController
    });
  }
}

export default angular.module('leptonApp.compareModal', [SaConfigService])
  .component('compareModal', {
    template: require('./compare-modal.html'),
    controller: CompareModalController,
    bindings: {
      value: '='
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/compare-modal/compare-modal.component.js